import React from 'react';
import PropTypes from 'prop-types';
import { mapKeys, round } from 'lodash';
import { Tooltip } from 'antd';
import classnames from 'classnames';
import style from './index.scss';

export const ParametersTabs = (props) => {
  const { tabs, activeKey, setActiveKey, data, weightage } = props;

  const getWeights = () => {
    let total = 0;
    mapKeys(
      weightage,
      (value, key) => (total = round(total + round(value, 2), 2))
    );
    return total;
  };

  return (
    <div className={style.tabContainer}>
      <div className={style.tabHeader}>
        <div className={style.tabHead}>
          {tabs.map((tab, index) => (
            <div
              className={classnames(
                style.tab,
                activeKey == tab.key ? style.active : ''
              )}
              key={index}
              id={`parametertab${tab.key}`}
              onClick={() => setActiveKey(tab.key)}>
              <Tooltip
                placement="topLeft"
                overlayClassName={style.tab_Weightage_tooltip}
                title={`Weight assigned: ${round(
                  weightage[data[tab.key]?.categoryType],
                  2
                )}%`}>
                {tab?.name}
              </Tooltip>
            </div>
          ))}
        </div>
        <div className={style.weightage}>
          <label>Total Weightage</label>
          <h4>{getWeights()}%</h4>
        </div>
      </div>
      <div className={style.tabBody}>
        {tabs.map((tab) => activeKey == tab.key && tab?.component())}
      </div>
    </div>
  );
};

ParametersTabs.defaultValues = {
  tabs: [],
  activeKey: '0',
  setActiveKey: null,
  data: [],
  weightage: {}
};

ParametersTabs.propTypes = {
  tabs: PropTypes.array,
  activeKey: PropTypes.string,
  setActiveKey: PropTypes.func,
  data: PropTypes.array,
  weightage: PropTypes.object
};

export default ParametersTabs;
